// @ts-strict-ignore
import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';

interface ProgressBarJsxProps {
  attrs?: {
    percent: number;
  };
}

export class ProgressBar extends Component<EmptyObj, ProgressBarJsxProps[`attrs`]> {
  static get attrsSchema(): AttrsSchema<ProgressBarJsxProps[`attrs`]> {
    return {
      ...super.attrsSchema,
      percent: {type: `number`, description: `Percentage progress out of 100`},
    };
  }

  get config() {
    return {
      template,
      css,
      useShadowDom: true,
      helpers: {
        getPercentStatus: () => {
          return Math.min(100, this.attr(`percent`));
        },
      },
    };
  }
}

export const ProgressBarEl = defineAndMakeJsxFactory<ProgressBarJsxProps>(`mp-progress-bar`, ProgressBar);
export const ProgressBarReact = panel2react<ProgressBarJsxProps>(`mp-progress-bar`, ProgressBar);
